import Vue from "vue";
import Vuetify from "vuetify/lib";
import VuetifyX from "vuetify";

import colors from "vuetify/lib/util/colors";
import "@mdi/font/css/materialdesignicons.css";
Vue.use(VuetifyX);

export default new Vuetify({
  theme: {
    themes: {
      light: {
        primary: colors.teal.base,
        secondary: colors.cyan.base,
        accent: colors.indigo.base,
        error: colors.deepOrange.base,
        warning: colors.orange.base,
        info: colors.lime.base,
        success: colors.green.base
      }
    }
  },
  icons: {
    iconfont: "mdi"
  }
});
